<script setup lang="ts">
const localePath = useLocalePath();
const facilityStore = useFacilityStore();

const plantName = computed(() => {
  return facilityStore.currentFacility?.name;
});
</script>

<template>
  <nuxt-link
    v-if="plantName"
    :to="localePath('/')"
    class="flex gap-2 items-center text-sm leading-4 font-normal text-ngray-1 whitespace-nowrap pr-2"
  >
    <span class="underline">{{ plantName }}</span>
    <base-icon name="fa6-regular:building" size="18px" />
  </nuxt-link>
</template>
